import React from 'react';
import { Link } from 'react-router-dom';

const GOLD = '#c8a04e';
const GA   = (a) => `rgba(200,160,78,${a})`;
const W    = (a) => `rgba(255,255,255,${a})`;

const COLS = [
  {
    heading: 'Quick Links',
    links: [
      { label: 'Features', href: '/#features', ext: false },
      { label: 'Pricing',  href: '/#pricing',  ext: false },
      { label: 'FAQ',      href: '/#faq',      ext: false },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms of Service', href: '/terms',   ext: false },
      { label: 'Privacy Policy',   href: '/privacy', ext: false },
      { label: 'Refund Policy',    href: '/refunds', ext: false },
    ],
  },
];

export default function Footer() {
  const lnkStyle = {
    fontSize: 13, color: W(0.32), textDecoration: 'none',
    display: 'block', marginBottom: 10, transition: 'color .15s',
  };
  const hoverOn  = e => e.currentTarget.style.color = W(0.7);
  const hoverOff = e => e.currentTarget.style.color = W(0.32);

  return (
    <footer style={{ background: '#000', position: 'relative', overflow: 'hidden' }}>

      {/* Top separator */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 1, background: 'rgba(255,255,255,0.06)' }} />

      {/* Grain overlay */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', opacity: 0.028,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='256' height='256'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='256' height='256' filter='url(%23n)'/%3E%3C/svg%3E")`,
      }} />

      <div style={{ position: 'relative', maxWidth: 1080, margin: '0 auto', padding: '56px 32px 0' }}>

        {/* Main row: logo+slogan left | columns right */}
        <div style={{ display: 'flex', gap: 48, marginBottom: 48, flexWrap: 'wrap' }}>

          {/* Left — logo + slogan + discord */}
          <div style={{ flex: '0 0 260px', maxWidth: 260 }}>
            <img
              src="/athena_logo.png"
              alt="Athena"
              style={{ width: 44, height: 44, objectFit: 'contain', marginBottom: 14, display: 'block',
                filter: 'none' }}
            />
            <p style={{ fontSize: 13, color: W(0.28), lineHeight: 1.75, margin: '0 0 20px' }}>
              Built for Rust players who refuse to lose.
            </p>
            <a
              href="https://discord.gg/9KWNw8CeZX"
              target="_blank" rel="noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 14px', borderRadius: 9, background: 'rgba(88,101,242,0.07)', border: '1px solid rgba(88,101,242,0.18)', color: 'rgba(148,155,255,0.75)', fontSize: 12, fontWeight: 600, textDecoration: 'none', transition: 'all .15s' }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(88,101,242,0.14)'; e.currentTarget.style.borderColor = 'rgba(88,101,242,0.32)'; e.currentTarget.style.color = 'rgba(168,175,255,0.95)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(88,101,242,0.07)'; e.currentTarget.style.borderColor = 'rgba(88,101,242,0.18)'; e.currentTarget.style.color = 'rgba(148,155,255,0.75)'; }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              Join Discord
            </a>
          </div>

          {/* Right — columns */}
          <div style={{ flex: 1, display: 'flex', gap: 40, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {COLS.map(col => (
              <div key={col.heading} style={{ minWidth: 120 }}>
                <span style={{ fontSize: 10, fontWeight: 700, color: W(0.2), letterSpacing: '0.18em', textTransform: 'uppercase', display: 'block', marginBottom: 16 }}>
                  {col.heading}
                </span>
                {col.links.map(({ label, href, ext }) =>
                  ext
                    ? <a key={label} href={href} target="_blank" rel="noreferrer" style={lnkStyle} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>{label}</a>
                    : <Link key={label} to={href} style={lnkStyle} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>{label}</Link>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '18px 0 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
          <span style={{ fontSize: 11.5, color: W(0.15) }}>
            &copy; {new Date().getFullYear()} Athena. All rights reserved. Not affiliated with any game developers.
          </span>
        </div>

      </div>
    </footer>
  );
}
